const BRAND = {
  eroadBrand: "#EE3124",
} as const;

const THEME = {
  decorativeBlue: "#1693DE",
  decorativeBlueDark: "#056DAD",
  decorativeBlueLight: "#91CEF2",
  decorativeGreen: "#53A32E",
  decorativeGreenDark: "#288000",
  decorativeGreenLight: "#8FDB6C",
  decorativeOrange: "#E86900",
  decorativeOrangeLight: "#FFBD87",
  decorativePurple: "#BF57FF",
  decorativePurpleDark: "#990AF0",
  decorativePurpleLight: "#E2B2FF",
  decorativeRed: "#FF584D",
  decorativeRedDark: "#C7362C",
  decorativeRedLight: "#FFB8B2",
  decorativeTeal: "#009E8C",
  decorativeTealDark: "#017A6C",
  decorativeTealLight: "#6EDBBF",
  decorativeYellow: "#C28300",
  decorativeYellowDark: "#996900",
  decorativeYellowLight: "#FFC547",
  onsurfaceCriticalRed: "#BD0D00",
  onsurfaceElevated: "#1D242C",
  onsurfaceFont: "#3B434B",
  onsurfaceGrayBorders: "#C7C9CB",
  onsurfaceSuccessGreen: "#39771D",
  onsurfaceTechnicalFont: "#6E7378",
  onsurfaceWarningOrange: "#996500",
  primaryBlueActive: "#124D86",
  primaryBlueDefault: "#1869B7",
  primaryBlueHover: "#4284C4",
  primaryBluePressed: "#1693DE",
  surfaceBlueHover: "#D8EBFD",
  surfaceCriticalRed: "#FFE5E3",
  surfaceCriticalRedTint: "#FFF1F1",
  surfaceLevel1: "#F8F8F8",
  surfaceLevel2: "#F1F1F2",
  surfaceLevel3: "#EAEAEB",
  surfaceOverlay: "#FFFFFF",
  surfacePurple: "#F5E6FD",
  surfaceSuccessGreen: "#D7F2CA",
  surfaceWarningOrange: "#FFF8EB",
} as const;

const RAG = {
  ragAmber: "#FAAB00",
  ragGreen: THEME.decorativeGreenDark,
  ragRed: THEME.decorativeRedDark,
} as const;

const DEPRECATED = {
  // MyEROAD's equivalent of AntD's alert has been designed incorrectly
  // with RAG colors that don't sufficiently contrast against the
  // non-deprecated versions of these colours.
  deprecatedSurfaceCriticalRed: "#FFECEB",
  // MyEROAD's equivalent of AntD's alert has been designed incorrectly
  // with RAG colored text that doesn't sufficiently contrast against the
  // non-deprecated surface backgrounnds.
  deprecatedRagAmberText: THEME.decorativeYellow,
} as const;

const colors = {
  ...BRAND,
  ...THEME,
  ...RAG,
  ...DEPRECATED,
};

export { colors };
